import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

interface Props {
  children: React.ReactNode;
}

function SlateWrapper({ children }: Props) {
  const classes = useStyles();

  return <div className={classes.root}>{children}</div>;
}

const useStyles = makeStyles(theme => ({
  root: {
    border: `0.5px solid ${theme.palette.grey[300]}`,
    borderRadius: 2,
    marginTop: theme.spacing(2),
  },
}));

export default SlateWrapper;
